import { render, staticRenderFns } from "./index.vue?vue&type=template&id=4f61d9ca&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"
import style0 from "./index.vue?vue&type=style&index=0&id=4f61d9ca&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f61d9ca",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\project\\huixin\\云商\\V12_saas版\\erp-flexible-web21-cloud-saas\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4f61d9ca')) {
      api.createRecord('4f61d9ca', component.options)
    } else {
      api.reload('4f61d9ca', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=4f61d9ca&scoped=true", function () {
      api.rerender('4f61d9ca', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/system/FormSet/index.vue"
export default component.exports